import React, { Component } from 'react';
import { Route, Redirect, Switch } from "react-router-dom";
import { connect } from 'react-redux'
import Navbar from './Components/Navbar/Navbar'
import Footer from './Components/Footer/Footer'
import Home from './Pages/Home/Home'
import Exhibitions from './Pages/Exhibitions/Exhibitions'
import News from './Pages/News/News'
import Events from './Pages/Events/Events'
import Frames from './Pages/Frames/Frames'
import LiveExhibition from './Pages/LiveExhibition/LiveExhibition'
import Materials from './Pages/Materials/Materials';
import Search from './Pages/Search/Search';
import Guestbook from './Pages/Guestbook/Guestbook';
import NotFound from './Pages/NotFound/NotFound';
import { ConnectedRouter } from 'connected-react-router'
import { history } from './Utils/configureStore'
import * as actionCreators from './Store/index'
import './App.css';

class App extends Component {


  render() {
    return (
      <ConnectedRouter history={history}>
        <div className="App">
          <Navbar></Navbar>
          <div>
            <Switch>
              <Route exact path="/" render={() => (
                <Redirect to="/home" />
              )} />
              <Route path="/home" render={() => <Home {...this.props}></Home>} />
              <Route path="/exhibitions" render={() => <Exhibitions {...this.props}></Exhibitions>} />
              <Route path="/news" render={() => <News {...this.props}></News>} />
              <Route path="/events" render={() => <Events {...this.props}></Events>} />
              <Route path="/frames" render={() => <Frames {...this.props}></Frames>} />
              <Route path="/materials" render={() => <Materials {...this.props}></Materials>} />
              <Route path="/live" render={() => <LiveExhibition {...this.props}></LiveExhibition>} />
              <Route path="/guestbook" render={() => <Guestbook {...this.props}></Guestbook>} />
              <Route path="/search" render={() => <Search term={this.props.term} onChange={this.props.onChangeTerm} results={this.props.results}></Search>} />
              <Route component={NotFound} />
            </Switch>
          </div>
          <Footer></Footer>
        </div>
      </ConnectedRouter>
    );

  }
}

const mapStateToProps = (store) => {
  return {
    term: store.basic.term,
    results: store.basic.results,
    modal: store.basic.modal,
    location: store.router.location,
    guest: store.guest.message,
    send: store.guest.status
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeTerm: (term) => dispatch(actionCreators.search(term)),
    onShowModal: (modal) => dispatch(actionCreators.show_modal(modal)),
    onUpdateField: (name,value) => dispatch(actionCreators.updateField(name,value)),
    onSubmitMessage: () => dispatch(actionCreators.submit())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);